import { useState } from "react"

export const useLocalStorage = (keyName: string, defaultValue: any) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const value = localStorage.getItem(keyName);
            if(value !== null) {
                return JSON.parse(value);
            } else {
                localStorage.setItem(keyName, defaultValue);
                return defaultValue;
            }
        } catch (error) {
            return defaultValue;
        }});
        const setValue = (newValue: any) => {
            try {
                localStorage.setItem(keyName, newValue);
            } catch (error) {}
            setStoredValue(newValue);
        };
        return [storedValue, setValue]
}